import { createRedirectLocation } from './postOperationRedirect';

export function requestLogin(router, locationOnSuccess) {
  let redirect = locationOnSuccess;

  if (!redirect) {
    const { pathname, search } = router.getCurrentLocation();
    redirect = pathname + search;
  }

  router.replace(createRedirectLocation('/login', redirect));
}
